import { Controller } from "@hotwired/stimulus"

// ย่อ/ขยายเนื้อหาการ์ด — เริ่มแบบย่อเห็นไม่กี่บรรทัด กด "อ่านเพิ่ม" ขยายลงมา กด "ย่อ" พับกลับ
// ความสูงตอนย่อกำหนดผ่าน data-collapse-height-value (ค่า CSS เช่น "7.75rem")
export default class extends Controller {
  static targets = ["content", "fade", "more", "less"]
  static values = { height: { type: String, default: "7.75rem" } }

  connect() {
    this.collapsed = true
    this.render()
  }

  toggle() {
    this.collapsed = !this.collapsed
    this.render()
    if (this.collapsed) this.element.scrollIntoView({ block: "nearest" })
  }

  render() {
    this.contentTarget.style.maxHeight = this.collapsed ? this.heightValue : "none"
    this.fadeTarget.classList.toggle("hidden", !this.collapsed)
    this.moreTarget.classList.toggle("hidden", !this.collapsed)
    this.lessTarget.classList.toggle("hidden", this.collapsed)
  }
}
